import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { RedirectService } from 'src/app/shared/services/redirect.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router,
    public translate: TranslateService,
    public redirectService: RedirectService) { }

  ngOnInit(): void {
  }

  advanceToEnroll() {
    this.router.navigate(['enrollment']);
  }

}
